<template>
  <div class="wrapper">
    <input 
      type="text" 
      v-model="localYearFrom" 
      placeholder="2012" 
      :max="max"
      :min="min"
      maxlength="4"
      pattern="\d{1,4}" 
      @blur="emitUpdate()"
    />
    <input 
      type="text" 
      v-model="localYearTo" 
      placeholder="2018" 
      :max="max"
      maxlength="4"
      pattern="\d{1,4}" 
      @blur="emitUpdate()"
    />
  </div>
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
    },
    min: {
      type: Number,
    }
  },
  data() {
    return {
      // Инициализация локальных переменных значениями из min и max
      localYearFrom: this.min,
      localYearTo: this.max,
    };
  },
  methods: {
    emitUpdate() {
      // Эмитим обновление только при потере фокуса
      this.$emit('update', { from: this.localYearFrom, to: this.localYearTo });
    }
  },
  watch: {
    max(newValue, oldValue) {
      // Проверяем, отличается ли новое значение от старого
      if (newValue !== oldValue && newValue !== this.localYearTo) {
        this.localYearTo = newValue;  // Обновляем только в случае изменения
      }
    },
    min(newValue, oldValue) {
      // Проверяем, отличается ли новое значение от старого
      if (newValue !== oldValue && newValue !== this.localYearFrom) {
        this.localYearFrom = newValue;  // Обновляем только в случае изменения
      }
    }
  }
};
</script>




<style scoped>
.wrapper{
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
input {
  border: none;              /* Убираем все бордеры */
  border-bottom: 1px solid rgb(222, 230, 234);; /* Добавляем только нижний бордер */
  outline: none;             /* Убираем контур при фокусе */
  padding: 8px 0;            /* Отступы только по вертикали */
  font-size: 16px;           /* Размер шрифта */
  width: 100%;               /* Ширина инпута на всю доступную ширину */
  max-width: 86px;
  /* Paragraph/P3: 16px Regular */
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}

input:focus {
  border-bottom-color: rgb(222, 230, 234);; /* Цвет нижнего бордера при фокусе */
}
</style>